<template>
  <div class="whiteborder">
    <VTable
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      @editTable="editTable"
      text="详情"
    >
      <template slot="other">
        <el-table-column label="申请状态" width="300">
          <template slot-scope="scope">
            <el-tag :type="dataMap[scope.row.reportStatus][2]">{{
              dataMap[scope.row.reportStatus][1]
            }}</el-tag>
          </template>
        </el-table-column>
      </template>
    </VTable>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import VTable from "@table/table.vue"; //
import { ReportListConfig } from "@/conf/ReportList.js";
import { getPreReportList } from "common/js/api";
import { mapMutations } from "vuex";

const map = {
  1: ["info", "待处理", "/ReportPlatform/ToProcessed"],
  2: ["success", "已受理", "/ReportPlatform/Processed"],
  3: ["danger", "已驳回", "/ReportPlatform/Processed"],
};

export default {
  name: "ReportList",

  components: {
    VTable,
  },

  data() {
    return {
      currentPage: 1,
      // 表格数据
      tableData: [],
      // 表格列配置
      tableConf: ReportListConfig,
      pageSize: 5,
      currentPage: 1,
      total: 0,
      dataMap: map,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    editTable(val) {
      const data = val.scope.row;

      this.$router.push({
        path: this.dataMap[data.reportStatus][2],
        query: {
          id: data.id,
          companyName: data.agencyName,
          status: data.reportStatus,
        },
      });
    },

    async getList() {
      const code = this.Cookies.get("identifyCode");
      const params = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        size: this.pageSize,
        page: this.currentPage,
        userInstitutionCode: code,
      };
      this.changeLoadingstate(true);

      const { result } = await getPreReportList(params);
      this.tableData = result.list;
      this.currentPage = result.pageNum;
      this.pageSize = result.pageSize;
      this.total = result.total;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    ...mapMutations(["changeLoadingstate"]),
  },
};
</script>

<style scoped>
.pagination {
  text-align: center;
}
</style>
